export function farloUiLightboxBlock(){
    const lightboxButtons = document.querySelectorAll('.farlo-ui-lightbox-toggle');
    let lightboxOverlay = document.querySelector('.farlo-ui-lightbox-overlay');

    // Create lightbox element if it doesn't exist
    if (!lightboxOverlay) {
        lightboxOverlay = document.createElement('div');
        lightboxOverlay.className = 'farlo-ui-lightbox-overlay';
        lightboxOverlay.innerHTML = `
            <div class="farlo-ui-lightbox-content">
                <button class="farlo-ui-lightbox-close">&times;</button>
                <div class="farlo-ui-lightbox-dynamic-content"></div>
            </div>
        `;
        document.body.appendChild(lightboxOverlay);
    }

    const lightboxClose = lightboxOverlay.querySelector('.farlo-ui-lightbox-close');
    const lightboxContent = lightboxOverlay.querySelector('.farlo-ui-lightbox-dynamic-content');

    lightboxButtons.forEach(button => {
        button.addEventListener('click', () => {
            const content = button.getAttribute('data-lightbox-content');
            if (content) {
                lightboxContent.innerHTML = content;
                lightboxOverlay.classList.add('is-active');
            }
        });
    });

    if (lightboxClose) {
        lightboxClose.addEventListener('click', () => {
            lightboxOverlay.classList.remove('is-active');
            lightboxContent.innerHTML = '';
        });
    }

    // Close on overlay click
    lightboxOverlay.addEventListener('click', (e) => {
        if (e.target === lightboxOverlay) {
            lightboxOverlay.classList.remove('is-active');
            lightboxContent.innerHTML = '';
        }
    });
}